import React, { useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { checkAuthenticated } from "../helpers/functions/checkAuthenticated";

type AuthProps = { children: React.ReactNode }

const AuthProvider: React.FC<AuthProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(checkAuthenticated())

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider